import React from 'react';
import { Location, Navigate, BrowserRouter, Route, Routes, useLocation, useParams } from 'react-router-dom';

import { APP_URL } from './defines';
import AppLayout from 'AppLayout';
import Home from 'pages/home';
import NotFound from 'pages/NotFound';
import Community from 'pages/community';
import LetsTalk from 'pages/LetsTalk';
import MeetMe from 'pages/MeetMe';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import Service from 'pages/service';
import Terms from 'pages/terms';

const RedirectToHome: React.FC = () => {
    return <Navigate to={`/home`} replace={true} />;
};

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Navigate to={`/home`} replace={true} />} />
                <Route path="/" element={<AppLayout/>} >
                    <Route path={APP_URL.HomePage} element={<Home/>}/>
                    <Route path={APP_URL.CommunityPage} element={<Community/>} />
                    <Route path={APP_URL.LetsTalkPage} element={<LetsTalk/>} />
                    <Route path={APP_URL.MeetMePage} element={<MeetMe/>} />
                    <Route path={APP_URL.PrivacyPolicyPage} element={<PrivacyPolicy/>} />
                    <Route path={APP_URL.ServicePage} element={<Service/>} />
                    <Route path={APP_URL.TermsPage} element={<Terms/>} />
                </Route>
                <Route path={APP_URL.NotFound} element={<NotFound />} />
                <Route path="*" element={<NotFound />}/>
            </Routes>
        </BrowserRouter>
    );
}